import { FormsConstants } from '../../types/forms-constants';
import { handOverUnsubmittedFormsSuccess } from '../actions/state.actions';
import { updateServiceActivityType } from '../actions/form.actions';
import { Action, createReducer, on } from '@ngrx/store';
import { initialServiceActivityState, ServiceActivityState } from '../state/service-activity.state';

export function updateServiceActivityTypeReducer(
    state: Readonly<ServiceActivityState>,
    props: { serviceActivity: FormsConstants.SERVICE_ACTIVITY_TYPES },
): Readonly<ServiceActivityState> {
    return props.serviceActivity ?? state;
}

export const createServiceActivityReducer = createReducer(
    initialServiceActivityState,
    on(updateServiceActivityType, updateServiceActivityTypeReducer),
    on(handOverUnsubmittedFormsSuccess, () => initialServiceActivityState),
);

export function serviceActivityReducer(
    state: Readonly<ServiceActivityState>,
    action: Action,
): Readonly<ServiceActivityState> {
    return createServiceActivityReducer(state, action);
}
